// extracted by mini-css-extract-plugin
module.exports = {"header":"SingleColor_header__3kBld","head":"SingleColor_head__1W6LJ"};